module.exports = __webpack_public_path__ + "static/media/featured-image.60e6b18b.avif";